import { GetCittaQuery } from '../../_graphql/generated';

export type CittaState = {
  loading: boolean;
  lista: GetCittaQuery['unita_amministrativa_citta'];
  failure: any;
};

export const initialCittaState: CittaState = {
  loading: false,
  lista: [],
  failure: '',
};
